export default {"src":"/_next/static/media/contact.90c03ecd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};